var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlanIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00002 3.99996V5.99996L10.6667 3.33329L8.00002 0.666626V2.66663C6.58553 2.66663 5.22898 3.22853 4.22878 4.22872C3.22859 5.22892 2.66669 6.58547 2.66669 7.99996C2.66669 9.04663 2.97335 10.02 3.49335 10.84L4.46669 9.86663C4.16669 9.31329 4.00002 8.66663 4.00002 7.99996C4.00002 6.93909 4.42145 5.92168 5.17159 5.17153C5.92174 4.42139 6.93915 3.99996 8.00002 3.99996V3.99996ZM12.5067 5.15996L11.5334 6.13329C11.8267 6.69329 12 7.33329 12 7.99996C12 9.06082 11.5786 10.0782 10.8284 10.8284C10.0783 11.5785 9.06089 12 8.00002 12V9.99996L5.33335 12.6666L8.00002 15.3333V13.3333C9.41451 13.3333 10.7711 12.7714 11.7713 11.7712C12.7715 10.771 13.3334 9.41445 13.3334 7.99996C13.3334 6.95329 13.0267 5.97996 12.5067 5.15996Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanIcon);
export default __webpack_public_path__ + "static/media/plan-icon.6f3448167c37fa81d26b6c494ee0bc10.svg";
export { ForwardRef as ReactComponent };